import React, { useEffect, useState } from 'react'
import './AdmitPatientEvent.scss'
import moment from 'moment'
import MobiScrollCalendar from '../../../../../../components/common/MobiScrollCalendar/MobiScrollCalendar'
import { getPatientEventHistory } from '../../../../../../helper/fusionHelper'
import AdmitPatientEventModal from './AdmitPatientEventModal'
import { visitFollowsDischarge } from './sharedPatientEventFunctions'
import Button from '../../../../../../components/common/Button/Button'
import { CarryOverIcon } from '../../../../../../components/common/shared/sharedPatientCode'
import { VISIT_STATUS } from '../../../../../../utils/statusConstants'
import { ENCOUNTER_TYPES } from '../../../../sharedConstants'

const ADMIT_CPT_CODES = ['99221', '99222', '99223']

function getShowInitialWarning(visit, current_cpts) {
  const isInitialCode =
    current_cpts?.some((cptObj) => ADMIT_CPT_CODES.includes(cptObj.code)) &&
    visit?.encounterType === ENCOUNTER_TYPES.INITIAL
  const isLast = visit?.status === VISIT_STATUS.last

  if (isLast) {
    // if we are a brand new encounter, show error if we are initial and last was initial
    return visit?.admitPatientEvent && isInitialCode
  }

  // if we are our own encounter, show error if we are initial but using someone else's admit date
  return (
    visit?.admitPatientEvent && visit?.admitPatientEvent?.charge_id !== visit._id && isInitialCode
  )
}

// the special admit date that Medrina wants
export default function AdmitPatientEventCard({
  visit,
  onChange,
  currentPatientAdmitDate,
  current_service_date_from,
  current_cpts,
  isAI,
}) {
  const [followsDischarge, setFollowsDischarge] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const patientAdmitDate =
    currentPatientAdmitDate === 'DISCHARGE'
      ? null
      : currentPatientAdmitDate || visit?.admitPatientEvent?.date

  useEffect(() => {
    // get patientEvent history
    if (visit.patient_id) {
      getPatientEventHistory(visit.patient_id).then((patientEventHistory) => {
        const followsDischarge = visitFollowsDischarge(
          current_service_date_from,
          patientEventHistory,
        )
        if (followsDischarge) {
          setFollowsDischarge(true)
          onChange('DISCHARGE')
        }
      })
    }
  }, [visit.patient_id, current_service_date_from])

  const showInitialCptWarning =
    currentPatientAdmitDate !== 'DISCHARGE' &&
    !followsDischarge &&
    getShowInitialWarning(visit, current_cpts)

  useEffect(() => {
    if (showInitialCptWarning && !isAI) {
      onChange('DISCHARGE')
    }
  }, [showInitialCptWarning, isAI])

  const showDateMismatchWarning =
    patientAdmitDate && moment(current_service_date_from).isBefore(moment(patientAdmitDate))

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <div className="admit-date-selector admit-date-card" onClick={() => setShowModal(true)}>
          <div className="label d-flex gap-2">
            Admission Date
            <CarryOverIcon visit={visit} currentPatientAdmitDate={currentPatientAdmitDate} />
          </div>
          <div className="admit-date-input">
            <MobiScrollCalendar
              placeholder="MM / DD / YYYY"
              value={patientAdmitDate ? moment.utc(patientAdmitDate).format('MM/DD/YYYY') : ''}
              disabled={true}
            ></MobiScrollCalendar>

            {(showDateMismatchWarning || followsDischarge) && (
              <div style={{ textWrap: 'auto' }}>
                {showDateMismatchWarning && (
                  <div id="warning-label">
                    Date of Service is prior to Admit Date, please update or remove Admit Date
                  </div>
                )}
                {followsDischarge && (
                  <div id="warning-label">
                    This encounter has no Admission Date following the most recent discharge. Please
                    update or leave blank.
                  </div>
                )}
              </div>
            )}
          </div>
          {(showInitialCptWarning || showDateMismatchWarning) && (
            <Button
              compressed
              style={{
                width: 'fit-content',
                margin: '4px',
                marginBottom: '0',
                fontSize: '0.85rem',
              }}
              onClick={(e) => {
                e.stopPropagation()
                onChange('DISCHARGE')
              }}
            >
              Remove Admit Date
            </Button>
          )}
        </div>
      </div>
      {showModal && (
        <AdmitPatientEventModal
          date={patientAdmitDate}
          visit={{
            ...visit,
            service_date_from: current_service_date_from,
            // if we have a 'DISCHARGE', then make the modal also be empty
            ...(!patientAdmitDate && { admitPatientEvent: null }),
          }}
          isPatientEventCard={true}
          onClose={() => {
            setShowModal(false)
          }}
          onChange={(newDate) => {
            setShowModal(false)
            onChange(newDate)
          }}
        />
      )}
    </>
  )
}
